import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a left arrow icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/arrow-left?f=classic&s=solid
 */
export const ArrowLeftIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faArrowLeft} {...props} />;
};
